import { notification } from 'antd';

const Notification = ({ type, message, description, duration = 4.5, placement, showProgress = true }) => {
  notification.config({
    placement: placement || 'bottomRight',
  });

  notification[type]({
    message,
    description,
    duration,
    showProgress
  });
};

export const showNotification = (type, message, description, placement, showProgress) => {
  Notification({
    type,
    message,
    description,
    placement,
    showProgress
  });
};

export default Notification;